<h2 mat-dialog-title>
  <span class="dialog-title">
    <span>Solicitud de cambio de horario</span>
    @if (!is_pending() && request(); as req) {
      <span class="status-pill" [class]="'status-' + req.status">{{ status_label() }}</span>
    }
  </span>
</h2>

<mat-dialog-content>
  @if (loading()) {
    <p class="loading-message">Cargando…</p>
  } @else {
    @let req = request()!;
    <p class="detail-line"><strong>Usuario:</strong> {{ user_name() }}</p>
    <p class="detail-line"><strong>Semana:</strong> {{ week_label() }}</p>
    <p class="detail-line detail-reason"><strong>Motivo:</strong> {{ req.reason }}</p>
    <p class="detail-line kpi-line">
      <strong>KPI actual:</strong>
      <span class="kpi-current-group">
        <span [class]="'kpi-chip kpi-' + req.current_schedule_compliance_kpi_evaluation">
          {{ current_kpi_chip_label() }}
        </span>
        @if (can_open_current_kpi_detail()) {
          <button
            type="button"
            mat-icon-button
            class="kpi-detail-button"
            matTooltip="Ver detalle del KPI actual"
            (click)="openCurrentScheduleComplianceKpiDetail()"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        }
      </span>
      <strong>KPI con cambio:</strong>
      <span [class]="'kpi-chip kpi-' + req.proposed_schedule_compliance_kpi_evaluation">
        {{ proposed_kpi_chip_label() }}
      </span>
    </p>

    <p class="detail-line">
      <strong>Horas semanales:</strong>
      {{ proposed_hours() | hourDecimalToHoursMinutes }}
      @if (expected_hours() !== null) {
        / {{ expected_hours()! | hourDecimalToHoursMinutes }}
      }
      @if (proposed_hours_mismatch_expected()) {
        <span class="hours-mismatch-icon" matTooltip="Las horas propuestas no coinciden con las esperadas">❌</span>
      }
    </p>

    <p class="legend">
      <span class="legend-item"><span class="legend-swatch bar-changed"></span> Cambio propuesto</span>
      <span class="legend-item"><span class="legend-swatch bar-removed"></span> Se elimina</span>
      <span class="legend-item"><span class="legend-swatch bar-unchanged"></span> Sin cambio</span>
    </p>

    <div class="days">
      @for (day of days(); track day.key) {
        <section class="day-block">
          <h3 class="day-title">
            <span>{{ day.title }}</span>
            <span class="day-title-emojis">
              <span class="day-title-emoji" [matTooltip]="day.location_tooltip">{{ day.location_emoji }}</span>
              @if (day.off_emoji) {
                <span class="day-title-emoji" [matTooltip]="day.off_tooltip">{{ day.off_emoji }}</span>
              }
            </span>
          </h3>
          @for (alert_message of day.alert_messages; track alert_message) {
            <div class="warning-message" role="alert">
              <mat-icon class="warning-message-icon">warning_outline</mat-icon>
              <div class="warning-message-text">{{ alert_message }}</div>
            </div>
          }
          <div class="timeline-row timeline-axis-row">
            <span class="row-label"></span>
            <div class="timeline-track axis-track">
              @for (tick of axis_hours(); track tick.hour) {
                <span class="axis-tick" [style.left.%]="tick.left_percent">{{ tick.hour }}</span>
              }
              @if (day.request_marker_left_percent !== null) {
                <span class="request-marker" [style.left.%]="day.request_marker_left_percent" matTooltip="Ahora"></span>
              }
            </div>
          </div>
          <div class="timeline-row">
            <span class="row-label">Actual</span>
            <div class="timeline-track">
              @for (bar of day.current; track $index) {
                <span
                  [class]="'bar bar-' + bar.kind + (bar.is_compact ? ' bar-compact' : '')"
                  [style.left.%]="bar.left_percent"
                  [style.width.%]="bar.width_percent"
                  [matTooltip]="bar.label"
                  [matTooltipDisabled]="!bar.is_compact"
                >
                  {{ bar.label }}
                </span>
              }
              @if (day.request_marker_left_percent !== null) {
                <span class="request-marker" [style.left.%]="day.request_marker_left_percent" matTooltip="Ahora"></span>
              }
            </div>
          </div>
          <div class="timeline-row">
            <span class="row-label">Propuesta</span>
            <div class="timeline-track">
              @for (bar of day.proposed; track $index) {
                <span
                  [class]="'bar bar-' + bar.kind + (bar.is_compact ? ' bar-compact' : '')"
                  [style.left.%]="bar.left_percent"
                  [style.width.%]="bar.width_percent"
                  [matTooltip]="bar.label"
                  [matTooltipDisabled]="!bar.is_compact"
                >
                  {{ bar.label }}
                </span>
              }
              @if (day.request_marker_left_percent !== null) {
                <span class="request-marker" [style.left.%]="day.request_marker_left_percent" matTooltip="Ahora"></span>
              }
            </div>
          </div>
          <div class="timeline-row">
            <span class="row-label">Fichaje</span>
            <div class="timeline-track">
              @for (bar of day.clock_registers; track $index) {
                <span
                  class="bar bar-clock"
                  [class.bar-compact]="bar.is_compact"
                  [style.left.%]="bar.left_percent"
                  [style.width.%]="bar.width_percent"
                  [matTooltip]="bar.label"
                  [matTooltipDisabled]="!bar.is_compact"
                >
                  {{ bar.label }}
                </span>
              }
              @if (day.request_marker_left_percent !== null) {
                <span class="request-marker" [style.left.%]="day.request_marker_left_percent" matTooltip="Ahora"></span>
              }
            </div>
          </div>
        </section>
      }
    </div>
  }
</mat-dialog-content>

@if (is_pending()) {
  <mat-dialog-actions align="end">
    <button mat-flat-button color="warn" type="button" (click)="reject()" [disabled]="saving()">Rechazar</button>
    <button mat-flat-button color="accent" type="button" (click)="accept()" [disabled]="saving()">Aceptar</button>
  </mat-dialog-actions>
}
